import React, { useState } from "react";
import "./viewFranchiseManagerRejectModal.css";

const ViewFranchiseManagerRejectModal = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    if (!reason.trim()) return;
    onSubmit(reason.trim());
    setReason("");
  };

  return (
    <div className="vfmr-overlay" onClick={onClose}>
      <div className="vfmr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="vfmr-header">
          <h3>Reject Documents</h3>
          <button className="vfmr-close" onClick={onClose} type="button" aria-label="Close">
            &times;
          </button>
        </div>

        <div className="vfmr-body">
          <label className="vfmr-label">Reason for rejection</label>
          <textarea
            className="vfmr-textarea"
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason..."
            autoFocus
          />
        </div>

        <div className="vfmr-footer">
          <button className="vfmr-btn vfmr-btn--cancel" onClick={onClose} type="button">
            Cancel
          </button>
          <button
            className="vfmr-btn vfmr-btn--submit"
            onClick={handleSubmit}
            type="button"
            disabled={!reason.trim()}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewFranchiseManagerRejectModal;